import React from 'react';

interface TwitterRendererProps {
  data: any;
}

const TwitterRenderer: React.FC<TwitterRendererProps> = ({ data }) => {
  if (!data.tweets) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-3">
        <div className="text-sm text-gray-500">No Twitter content available</div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-3">
      <div className="text-sm text-gray-600">
        <strong>Type:</strong> {data.content_type} ({data.tweets?.length} tweets)
      </div>

      {data.tweets?.map((tweet: any, index: number) => (
        <div key={index} className="border-l-2 border-gray-300 pl-3">
          <div className="text-xs text-gray-500 mb-1">
            Tweet {tweet.position} of {data.tweets.length}
            {tweet.thread_indicator && <span> • {tweet.thread_indicator}</span>}
          </div>

          <div className="text-gray-800 whitespace-pre-wrap text-sm">{tweet.content}</div>

          <div className="flex flex-wrap gap-2 mt-2">
            {tweet.hashtags?.map((tag: string, i: number) => (
              <span key={i} className="text-blue-500 text-sm bg-blue-50 px-2 py-1 rounded">
                {tag}
              </span>
            ))}
          </div>

          <div className="text-xs text-gray-500 mt-1">
            <strong>Tone:</strong> {tweet.tone} • <strong>Chars:</strong> {tweet.content.length}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TwitterRenderer;
